import { FunctionComponent, ReactNode } from 'react'

import styled, { css } from 'styled-components'

import { Image } from '@utils/cook/types'
import ResponsiveImageV2 from '@components/ResponsiveImageV2'
import { ImageRatios } from '@components/ResponsiveImageV2/types'
import { WIDTHS } from '@components/TeaserToi/Image'

interface ImageWrapperProps {
  className?: string
  children?: ReactNode
}

const IMAGE = {
  src: '/incoming/21348269-v0-leserreporter.png',
  alt: 'Leserreporter',
  width: 4096,
  height: 2927,
  crops: {
    '16_9': {
      x: 0,
      y: 310,
      width: 4096,
      height: 2306,
    },
    '1_1': {
      x: 584,
      y: 0,
      width: 2927,
      height: 2927,
    },
  },
} as const satisfies Image<'16_9' | '1_1'>

const RATIOS = {
  desktop: '16_9',
  tablet: '16_9',
  mobile: '1_1',
} as const satisfies ImageRatios

const StyledImageWrapper = styled(ResponsiveImageV2)`
  ${({
    theme: {
      colors: { staticBlack },
      utils: { opacity },
      spacing: { spacing16 },
    },
  }) => css`
    border-radius: ${spacing16};
    overflow: hidden;

    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        0deg,
        ${opacity(staticBlack, '00')} 25%,
        ${opacity(staticBlack, 'CC')} 75%
      );
    }
  `}
`

const ImageWrapper: FunctionComponent<ImageWrapperProps> = ({
  children,
  className,
}) => {
  const { src, alt, crops } = IMAGE
  return (
    <StyledImageWrapper
      src={src}
      alt={alt}
      crops={crops}
      ratios={RATIOS}
      widths={WIDTHS}
      className={className}
    >
      {children}
    </StyledImageWrapper>
  )
}

export default ImageWrapper
